import React, { useMemo, useState } from "react";
import {
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import _ from "lodash";
import ExternalApplicationRow from "./ExternalApplicationRow";
import Button from "@mui/material/Button";
import { ExternalLawyerApplication } from "../../types/ExternalLawyerApplication";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { useInfiniteQuery } from "@tanstack/react-query";
import { HydraCollectionResult } from "../../types/HydraCollectionResult";
import { fetchCollection } from "../../services/ReactQuery/reactQueryService";

export default function ExternalApplications({}) {
  const [filter, setFilter] = useState<string>("applied");

  const {
    data: applicationPages,
    hasNextPage,
    fetchNextPage,
  } = useInfiniteQuery({
    queryKey: ["externalLawyerApplications", filter],
    initialPageParam: `external_lawyer_applications?status[]=${filter}&page=1&order[created]=desc`,
    queryFn: ({ pageParam }) =>
      fetchCollection(pageParam) as Promise<HydraCollectionResult<ExternalLawyerApplication>>,
    getNextPageParam: (lastPage) => {
      return lastPage["hydra:view"]["hydra:next"];
    },
  });

  const applications = useMemo(() => {
    if (applicationPages?.pages) {
      return applicationPages.pages
        .map((page) => {
          return page["hydra:member"];
        })
        .flat();
    }

    return [];
  }, [applicationPages]);

  const filteredApplications = _.filter(applications, (application) => application.status === filter);

  return (
    <>
      <Stack direction={"row"} sx={{
        justifyContent: "flex-end"
      }}>
        <FormControl>
          <Select
            onChange={(event: SelectChangeEvent) => setFilter(event.target.value)}
            value={filter}
            label={"Status"}
          >
            <MenuItem value={"applied"}>Zu Prüfen</MenuItem>
            <MenuItem value={"denied"}>Abgelehnt</MenuItem>
          </Select>
          <InputLabel>Status</InputLabel>
        </FormControl>
      </Stack>
      <Paper sx={{ padding: "2rem", marginTop: "1rem" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name des Bewerbers</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Eingereicht am</TableCell>
              <TableCell>Abgelehnt am</TableCell>
              <TableCell>Geprüft von</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {_.map(filteredApplications, (application) => (
              <ExternalApplicationRow key={application.id} application={application} />
            ))}
            {filteredApplications.length < 1 && (
              <TableRow>
                <TableCell colSpan={5} sx={{ textAlign: "center", color: "text.light" }}>
                  Keine Einträge
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {hasNextPage && (
          <Button fullWidth={false} sx={{ margin: "2rem auto", display: "block" }} onClick={() => fetchNextPage()}>
            Mehr laden
          </Button>
        )}
      </Paper>
    </>
  );
}
